const YesNoNode = require('../YesNoNode');
const UseAbility = require('../UseAbility');
const Q_which_summon = require('./Q_which_summon');
const BattleCalc = require('../../BattleCalc');

const SelfBuffDecision = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.YES] = new Q_which_summon(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'bless')) {
    node.branches[node.NO] = new UseAbility({
      actor,
      abilityHandle: 'bless',
      staticTarget: actor,
      altNode: node.branches[node.YES],
    });
  } else {
    node.branches[node.NO] = node.branches[node.YES];
  }

  node.yesNoEvalFunction = function () {
    return BattleCalc.getCondition(actor, 'blessed');
  };

  return node;
};
module.exports = SelfBuffDecision;
